import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {SettingsModel} from "../../../_stores/settings/_models/settings.model";
import {Store} from "@ngxs/store";
import {Router} from "@angular/router";
import {SettingsState} from "../../../_stores/settings/_state/settings.state";
import {RouterSelectors} from "../../../_stores/router/router.selectors";
import {TRANSLOCO_SCOPE} from "@ngneat/transloco";
import {WorkbookModel} from "../../../_stores/workbooks/_models/workbooks.model";
import {WorkbooksState} from "../../../_stores/workbooks/_state/workbooks.state";

@Component({
  selector: 'bh-workbooks-list',
  templateUrl: './bh-workbooks-list.component.html',
  styleUrls: ['./bh-workbooks-list.component.scss'],
  providers: [{ provide: TRANSLOCO_SCOPE, useValue: { scope: 'components/workbooks-list', alias: 'pages.workbooks' }}]
})
export class BhWorkbooksListComponent implements OnInit, OnDestroy {
  @Input() count: number;
  @Input() description: boolean;
  @Input() title: boolean = true;
  @Input('title_text') set _title_text(_title_text) {
    if (_title_text) {
      this.interface.title_text = _title_text;
    }
  }
  @Input() sidebar: boolean = false;
  @Input() bestselling: boolean = false;
  @Input() featured: boolean = false;
  interface: {
    settings: SettingsModel,
    workbooks: WorkbookModel[],
    title_text: string,
    _cache: any
  } = {
    settings: undefined,
    workbooks: [],
    title_text: null,
    _cache: {
      workbooks_tab: 'featured',
      workbooks: [],
      subscribe: {
        settings: undefined,
        workbooks:undefined,
        router: undefined,
      }
    }
  }

  constructor(private store: Store, private cdr: ChangeDetectorRef,private router: Router) {}

  ngOnInit(): void {
    this.initSettings();
    this.initWorkbooks();
    this.initRouteParams();
  }
  ngOnDestroy(): void {
    if (!this.interface._cache) {return}
    Object.keys(this.interface._cache.subscribe).forEach((_subscribe) => {
      if (this.interface._cache.subscribe[_subscribe]) {
        this.interface._cache.subscribe[_subscribe].unsubscribe();
      }
    });
  }

  initSettings(): void {
    this.interface._cache.subscribe.settings = this.store.select(SettingsState.selectSettings).subscribe((res: any)=> {
      this.interface.settings = res;
      this.cdr.detectChanges();
    });
  }
  initWorkbooks(): void {
    this.interface._cache.subscribe.workbooks = this.store.select(WorkbooksState.selectStoreWorkbooks).subscribe((_workbooks: WorkbookModel[])=> {
      if(!_workbooks) { return;}
      if(this.interface.workbooks.length > 0) { return;}

      if(this.bestselling) {
        this.interface.workbooks = _workbooks.filter((_w) => _w.badges.best_selling);
      }
      else if(this.featured) {
        this.interface.workbooks = _workbooks
      }
      else {
        this.interface.workbooks = _workbooks;
      }
      this.interface._cache.workbooks = this.interface.workbooks;
    });
  }
  initRouteParams(): void {
    this.interface._cache.subscribe.router = this.store.select(RouterSelectors.params).subscribe((_params) => {

    });
  }

  actionUpdateWorkbooks(tab: string): void {
    if(this.interface._cache.workbooks_tab == tab) {
      return;
    }
    this.interface._cache.workbooks_tab = tab;
    const _wb = [...this.interface._cache.workbooks];
    this.interface.workbooks = [];
    if(tab == 'on_sale') {
      this.interface.workbooks = _wb.filter((_w) => _w.badges.sales);
    }
    else {
      this.interface.workbooks = _wb;
    }


  }
}

